import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

/**
 * A max-width container that's centered on the page to
 * with horizontal margins. Used to implement Figma layouts
 * that were designed within the Currency grid system.
 */
var CenteredContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classNames(classes('max-width-container', 'margin-horizontal-auto', 'padding-horizontal-3', 'padding-horizontal-5--wide'), otherProps.className),
    ref: ref
  }), children);
});
CenteredContainer.displayName = 'CenteredContainer';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  CenteredContainer.propTypes = {
    children: PropTypes.node.isRequired
  };
}

export default CenteredContainer;